import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { Component } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { SelectBox } from 'devextreme-react/select-box';  //npm install --save react-select
import { getRequestParams } from '../../helpers/globalfunctions.js';

export class ServiceAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowId: 0,
            isSubmited: false,
            addEditServiceAreaDataModalIsOpen: false,
            serviceAreaList: [],
            locationList: [],
            locationId: 0,
            serviceArea: '',
            isActive: false,
            errors: {
                locationId: "",
                serviceArea: "",
            }
        }
        this.handleaddEditServiceAreaSubmit = this.handleaddEditServiceAreaSubmit.bind(this);
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    }
    componentDidMount = () => {
        this.getServiceAreaList();
    }
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'refresh',
                onClick: this.getServiceAreaList()
            }
        });
    }
    async getServiceAreaList() {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('serviceArea-api/0', requestParams);
        const data = await response.json();
        if (data !== null && data.locationServiceArea.length > 0) {
            this.setState({
                serviceAreaList: data.locationServiceArea
            });
        }
    }
    async LocationList() {
        const requestParams = getRequestParams('GET', '');
        const response = await fetch('account-api/locations', requestParams);
        const data = await response.json();
        if (data !== null && data.locations.length > 0) {
            this.setState({
                locationList: data.locations
            });
        }
    }

    handleLocationInputChange = (data) => {
        this.setState({ locationId: (data.selectedItem != null ? data.selectedItem.locationId : 0) })

        if (data.selectedItem === null) {
            this.state.errors["locationId"] = "Please select location.";
        }
        else {
            this.state.errors["locationId"] = "";
        }
    }

    addEditServiceAreaControl = (e, data) => {
        if (data != null) {
            e.preventDefault();
            this.setState({
                rowId: data.id,
                addEditServiceAreaDataModalIsOpen: true,
                locationId: data.locationId,
                serviceArea: data.name !== null || data.name !== "" ? data.name : "",
                isActive: data.enable === true ? true : false
            });
        }
        else {
            this.setState({
                rowId: 0,
                addEditServiceAreaDataModalIsOpen: true,
            });
        }
    }
    openServiceAreaDataModal = () => {
        this.LocationList();
    }
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let errors = this.state.errors;
        switch (name) {
            case 'serviceArea':
                errors.serviceArea = "";
                if (value.trim() === "") {
                    this.setState({ serviceArea: '' });
                    errors.serviceArea = "Please enter service area name.";
                } else {
                    this.setState({ serviceArea: value });
                }
                break;
            default:
                this.setState({
                    [name]: value
                });
                break;
        }
    }
    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.locationId = "";
        errors.serviceArea = "";

        if (this.state.locationId === 0 ) {
            formIsValid = false;
            errors.locationId = "Please select Location.";
        }
        if (this.state.serviceArea.trim() === "") {
            formIsValid = false;
            errors.serviceArea = "Please enter service Area name.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    async handleaddEditServiceAreaSubmit(e) {
        e.preventDefault();
        this.setState({ isSubmited: true });
        if (this.handleValidation()) {
            var addEditRequest = new Object();
            addEditRequest.Id = this.state.rowId;
            addEditRequest.Name = this.state.serviceArea;
            addEditRequest.LocationId = this.state.locationId;
            addEditRequest.IsActive = this.state.rowId > 0 ? this.state.isActive : true;

            const requestParams = getRequestParams('POST', addEditRequest);
            const response = await fetch('serviceArea-api/addEditLocationServiceArea/', requestParams);
            const data = await response.json();
            Swal.fire({
                icon: data.isSuccess ? 'success' : 'error',
                title: data.isSuccess ? 'Success' : 'Oops...',
                text: data.resultMessage,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (data.isSuccess) {
                    if (result.isConfirmed) {
                        this.setState({ isSubmited: false, addEditServiceAreaDataModalIsOpen: false });
                        this.getServiceAreaList();
                        this.closeaddEditServiceAreaModal();
                    }
                } else {
                    this.setState({ isSubmited: false })
                }
            })
        }
        else {
            this.setState({ isSubmited: false })
        }

    }
    closeaddEditServiceAreaModal = () => {
        this.setState({
            rowId: 0,
            addEditServiceAreaDataModalIsOpen: false,
            isSubmited: false,
            locationId: 0,
            serviceArea: '',
            isActive: false,
            errors: {
                locationId: "",
                serviceArea: ""
            }
        });
        this.getServiceAreaList();
    }

    render() {
        const serviceAreaModalTitle = this.state.rowId > 0 ? "Edit Service Area" : "Add Service Area"
        const renderEditGridCell = (data) => {
            return <div>&nbsp;&nbsp;
                <a href="#" className="fas fa-pen icon text-info" title="Edit" onClick={(e) => { this.addEditServiceAreaControl(e, data.data) }} ></a>&nbsp;&nbsp;
            </div>;
        }
        return (<div className="content-wrapper">
            <div className="content-header">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-sm-6 col-md-6 col-lg-6">
                            <h1 className="m-0 text-dark">Service Area</h1>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <ol className="breadcrumb float-sm-right">
                                <NavItem>
                                    <NavLink tag={Link} to="/location/list" className="btn btn-block btn-outline-secondary btn-sm"><i className="fas fa-map-marker-alt"></i> Location</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/serviceareazone/list" className="btn btn-block btn-outline-secondary btn-sm"><i className="fas fa-map-pin"></i> Service Area Zone</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink onClick={(e) => { this.addEditServiceAreaControl(e, null) }} className="btn btn-block btn-outline-secondary btn-sm"><i className="fas fa-plus"></i> Add Service Area</NavLink>
                                </NavItem>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="card card-grid">
                    <div className="card-body">
                        <DataGrid
                            dataSource={this.state.serviceAreaList}
                            keyExpr="id"
                            selection={{ mode: 'single' }}
                            columnsAutoWidth={false}
                            showColumnLines={false}
                            showRowLines={true}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            showBorders={true}
                            allowColumnResizing={true}
                            columnResizingMode='widget'
                            onToolbarPreparing={this.onToolbarPreparing}>
                            <Column dataField="id" width={50} caption="" allowFiltering={false} allowSorting={false} cellRender={renderEditGridCell} />
                            <Column dataField="locationName" caption="Location" allowFiltering={true} allowSorting={true} />
                            <Column dataField="name" caption="Service Area" allowFiltering={true} allowSorting={true} />
                            <Column dataField="status" caption="Status" />
                            <SortByGroupSummaryInfo summaryItem="count" />
                            <GroupPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                            <Grouping autoExpandAll={true} />
                            <Paging defaultPageSize={20} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true}/>
                            <Export enabled={true} allowExportSelectedData={false} />
                            <ColumnChooser enabled={true} />
                            <ColumnFixing enabled={true} />

                        </DataGrid>
                    </div>
                </div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.addEditServiceAreaDataModalIsOpen}
                    className={"react-modal edit-service-modal"}
                    onAfterOpen={this.openServiceAreaDataModal}
                    onRequestClose={this.closeaddEditServiceAreaModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                >
                    <form method="post" onSubmit={this.handleaddEditServiceAreaSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">{serviceAreaModalTitle}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeaddEditServiceAreaModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <label>Location <span className="text-red">*</span></label>
                                        <SelectBox
                                            dataSource={this.state.locationList.length > 0 ? this.state.locationList : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select location"
                                            name="locationId"
                                            defaultValue={0}
                                            value={this.state.locationId}
                                            displayExpr='locationName'
                                            valueExpr='locationId'
                                            onSelectionChanged={this.handleLocationInputChange}
                                            showClearButton={true}
                                            disabled={this.state.rowId > 0 ? true : false}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["locationId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["locationId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <label>Service Area <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control form-textbox form-control-sm" name="serviceArea" title="Service Area" placeholder="Enter service area" maxLength="50" value={this.state.serviceArea} onChange={this.handleInputChange} />
                                        {this.state.errors["serviceArea"].length > 0 && <span className="error invalid-feedback">{this.state.errors["serviceArea"]}</span>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <div className="form-check" style={{ display: this.state.rowId > 0 ? 'inline-block' : 'none' }}>
                                            <input className="form-check-input" type="checkbox" id="isActive" name="isActive" checked={this.state.isActive} onChange={this.handleInputChange} />
                                            <label className="form-check-label" htmlFor="isActive"> Is Active</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success btn-sm" onClick={this.handleaddEditServiceAreaSubmit} >
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Save"><i className="fas fa-save"></i> Save</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.closeaddEditServiceAreaModal} title="Close"><i className="fas fa-times"></i> Close</button>
                        </div>
                    </form>
                </Modal>
            </div>
        </div >)
    }
}